import { TextArea } from 'components/shared/TextField/TextArea';
import { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';

import type { TradeCommentProps } from './TradeComment.connect';
import { connectTradeComment } from './TradeComment.connect';

const Component: FC<TradeCommentProps> = ({ quoteId, comment, onCommentChanged }) => {
  const { formatMessage } = useIntl();

  const onValueChanged = useCallback(
    (newComment: any) => onCommentChanged(quoteId, newComment),
    [onCommentChanged, quoteId],
  );
  const placeholderContent = formatMessage({ id: 'trade.comment.placeholder' });

  return (
    <div className="mx-3">
      <TextArea
        className="form-control d-block mt-3"
        placeholder={placeholderContent}
        e2e="trade-comment"
        value={comment}
        onValueChanged={onValueChanged}
        rows={2}
      />
    </div>
  );
};

export const TradeComment = connectTradeComment(Component);
